import React, { useEffect, useState } from "react";
import axios from "axios";

const PAGE_SIZE = 13;

const SmsLog = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFailuresOnly, setShowFailuresOnly] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchLogs = async () => {
    setLoading(true);
const token = localStorage.getItem("authToken");
    try {
  const token = localStorage.getItem("authToken");
  const response = await axios.get("https://api.pharmacegroup.co.uk/smslog", {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  if (Array.isArray(response.data)) {
    const sortedLogs = response.data.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
    setLogs(sortedLogs);
  }
} catch (error) {
  console.error("Error fetching SMS logs:", error);
} finally {
  setLoading(false);
}

  };

  useEffect(() => {
    fetchLogs();
  }, []);

  // Auto-refresh every minute
  useEffect(() => {
    const id = setInterval(() => {
      fetchLogs();
    }, 60000);
    return () => clearInterval(id);
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date)) return "-";
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yy = String(date.getFullYear()).slice(2);
    const hh = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${yy} ${hh}:${min}`;
  };

  const filteredLogs = logs.filter((log) => {
    const combined = JSON.stringify(log).toLowerCase();
    const matchesSearch = combined.includes(searchTerm.toLowerCase());

    let passesFailureCheck = true;
    if (showFailuresOnly) {
      const date = new Date(log.sentByBackendAt);
      passesFailureCheck = log.sentByBackendAt && !isNaN(date);
    }

    return matchesSearch && passesFailureCheck;
  });

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, showFailuresOnly]);

  const totalPages = Math.max(1, Math.ceil(filteredLogs.length / PAGE_SIZE));
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const endIndex = startIndex + PAGE_SIZE;
  const paginatedLogs = filteredLogs.slice(startIndex, endIndex);

  const canPrev = currentPage > 1;
  const canNext = currentPage < totalPages;

  // Determine if any log has processOutcome so we can conditionally display the column
  const hasProcessOutcome = logs.some(l => typeof l?.processOutcome !== "undefined");

  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "auto" }}>
      <div style={{ margin: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "6px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            width: "300px",
            fontSize: "14px",
          }}
        />
        <label style={{ display: "flex", alignItems: "center", fontSize: "14px" }}>
          <input
            type="checkbox"
            checked={showFailuresOnly}
            onChange={(e) => setShowFailuresOnly(e.target.checked)}
            style={{ marginRight: "5px" }}
          />
          Show failures only
        </label>
      </div>

      {loading ? (
        <div>Loading SMS logs...</div>
      ) : (
        <>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead style={{ position: "sticky", top: 0, backgroundColor: "#e5e7eb", zIndex: 1 }}>
              <tr>
                <th style={{ padding: "4px", border: "1px solid #d1d5db" }}>Created</th>
                <th style={{ padding: "4px", border: "1px solid #d1d5db" }}>Requested</th>
                <th style={{ padding: "4px", border: "1px solid #d1d5db" }}>Sent</th>
                <th style={{ padding: "4px", border: "1px solid #d1d5db" }}>Send status</th>{/* added */}
                <th style={{ padding: "4px", border: "1px solid #d1d5db" }}>Received</th>
                <th style={{ padding: "4px", border: "1px solid #d1d5db" }}>Backend Sent</th>
                <th style={{ padding: "4px", border: "1px solid #d1d5db" }}>Complete</th>
                <th style={{ padding: "4px", border: "1px solid #d1d5db" }}>Message</th>
                <th style={{ padding: "4px", border: "1px solid #d1d5db" }}>Status</th>
                {hasProcessOutcome && (
                  <th style={{ padding: "4px", border: "1px solid #d1d5db" }}>Process Outcome</th>
                )}
              </tr>
            </thead>
            <tbody>
              {paginatedLogs.map((log, index) => {
                let bgColor = "";
                if (log.isDeleted === true && log.status === "DELIVERED") {
                  bgColor = "lightgreen";
                } else if (log.isDeleted === true && log.sentByBackendAt) {
                  const date = new Date(log.sentByBackendAt);
                  if (!isNaN(date)) {
                    bgColor = "coral";
                  }
                } else if (log.isDeleted === false) {
                  bgColor = "orange";
                } else {
                  bgColor = index % 2 === 0 ? "white" : "#f3f4f6"; // Tailwind gray-100
                }

                return (
                  <tr key={index} style={{ backgroundColor: bgColor }}>
                    <td style={{ padding: "4px", border: "1px solid #d1d5db", textAlign: "center" }}>{formatDate(log.createdAt)}</td>
                    <td style={{ padding: "4px", border: "1px solid #d1d5db", textAlign: "center" }}>{formatDate(log.androidServiceInvokedAt)}</td>
                    <td style={{ padding: "4px", border: "1px solid #d1d5db", textAlign: "center" }}>{formatDate(log.smsSentReceiptAt)}</td>
                    <td style={{ padding: "4px", border: "1px solid #d1d5db", textAlign: "center" }}>
                      {log.simDeliveryFailReason || "-"}
                    </td>
                    <td style={{ padding: "4px", border: "1px solid #d1d5db", textAlign: "center" }}>{formatDate(log.smsDeliveryReceiptAt)}</td>
                    <td style={{ padding: "4px", border: "1px solid #d1d5db", textAlign: "center" }}>{formatDate(log.sentByBackendAt)}</td>
                    <td style={{ padding: "4px", border: "1px solid #d1d5db", textAlign: "center" }}>
                      <input type="checkbox" checked={log.isDeleted === true} readOnly />
                    </td>
                    <td
                      style={{
                        padding: "4px",
                        border: "1px solid #d1d5db",
                        textAlign: "center",
                        maxWidth: "300px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontSize: "12px",
                      }}
                      title={log.message}
                    >
                      {log.message}
                    </td>
                    <td style={{ padding: "4px", border: "1px solid #d1d5db", textAlign: "center" }}>{log.status}</td>
                    {hasProcessOutcome && (
                      <td style={{ padding: "4px", border: "1px solid #d1d5db", textAlign: "center" }}>
                        {typeof log.processOutcome !== "undefined" ? String(log.processOutcome) : "-"}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* Pagination Bar */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px",
              borderTop: "1px solid #e5e7eb",
              background: "#fafafa",
              position: "sticky",
              bottom: 0,
            }}
          >
            <span style={{ fontSize: "13px", color: "#555" }}>
              Showing {filteredLogs.length === 0 ? 0 : startIndex + 1}–
              {Math.min(filteredLogs.length, endIndex)} of {filteredLogs.length}
            </span>

            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "6px" }}>
              <button
                onClick={() => setCurrentPage(1)}
                disabled={!canPrev}
                style={{
                  padding: "6px 10px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  background: canPrev ? "#fff" : "#f3f4f6",
                  cursor: canPrev ? "pointer" : "not-allowed",
                  color: canPrev ? "#000" : "#999",
                  fontWeight: "bold"
                }}
              >
                « First
              </button>

              <button
                onClick={() => { if (canPrev) setCurrentPage(p => Math.max(1, p - 1)); }}
                disabled={!canPrev}
                style={{
                  padding: "6px 10px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  background: canPrev ? "#fff" : "#f3f4f6",
                  cursor: canPrev ? "pointer" : "not-allowed",
                  color: canPrev ? "#000" : "#999",
                  fontWeight: "bold"
                }}
              >
                ‹ Prev
              </button>

              <span style={{ fontSize: "13px" }}>
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={() => { if (canNext) setCurrentPage(p => Math.min(totalPages, p + 1)); }}
                disabled={!canNext}
                style={{
                  padding: "6px 10px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  background: canNext ? "#fff" : "#f3f4f6",
                  cursor: canNext ? "pointer" : "not-allowed",
                  color: canNext ? "#000" : "#999",
                  fontWeight: "bold"
                }}
              >
                Next ›
              </button>

              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={!canNext}
                style={{
                  padding: "6px 10px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  background: canNext ? "#fff" : "#f3f4f6",
                  cursor: canNext ? "pointer" : "not-allowed",
                  color: canNext ? "#000" : "#999",
                  fontWeight: "bold"
                }}
              >
                Last »
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SmsLog;
